import { TravelReservation_Reservation_ReceiptDetails } from './travel-reservation-support-interface';
import {
  Ancillaries,
  PostalAddress
} from './travel-reservation-vacation-interface';

export interface TravelReservation_Additional_Props {
  umnr?: boolean;
  status?: string;
  agency?: string;
  holdExpirationUtcDateTime?: string;
  receiptDetails?: TravelReservation_Reservation_ReceiptDetails;
  packageType?: string;
  paymentStatus?: string;
  lifeStyleCode?: string;
  landDestCode?: string;
  vacationDestinationStation?: TravelReservation_DLV_Stn;
  vacationOriginStation?: TravelReservation_DLV_Stn;
  ancillaries?: Ancillaries[];
  isViewOnly?: boolean;
  isMultiPNR?: boolean;
}

export interface TravelReservation_DLV_Stn {
  code: string;
  name: string;
  postalAddress?: PostalAddress;
}
